import { Link } from "react-router-dom";
import { addPubParamToUrl } from "../../../helpers/add-pub-param-to-url";

export function Breadcrumbs({ breadcrumb, breadcrumb_redirect, title }) {
    const urlParams = new URLSearchParams(window.location.search);
    const advId = urlParams.get("advId");
    const pubValue = urlParams.get("pub");
    return (
        <div>
            <ol className="breadcrumb fs-sm mb-1">
                <li className="breadcrumb-item">
                    <Link href="/pub/dashboard/revenue" to={
                        advId ? addPubParamToUrl(`/adv/home?advId=${advId}`, pubValue, advId) : '/pub/dashboard/revenue'
                    }>
                        {advId ? "ADV Home" : "PUB Home"}
                    </Link>
                </li>
                <li className="breadcrumb-item">
                    {breadcrumb}
                </li>
                <li className="breadcrumb-item" aria-current="page">
                    {title}
                </li>
            </ol>
            <h2 className="main-title mb-0">{title}</h2>
        </div>
    )
}